import React, { useState } from "react"
//import axios from "axios"

import * as style from "./form.module.scss"

function Form() {
  const [values, setValues] = useState({
    mailSent: false,
    error: false,
    name: "",
    email: "",
    subject: "",
    message: "",
    mathtest: "",
  })

  const set = name => {
    return ({ target: { value } }) => {
      setValues(oldValues => ({ ...oldValues, [name]: value }))
    }
  }

  const saveFormData = async () => {
    if (values.mathtest === "4" || values.mathtest === "22") {
      const response = await fetch(
        "https://debbiemowry.com/processing/form-to-email.php",
        {
          method: "POST",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(values),
        }
      )
      if (response.status !== 200) {
        throw new Error(`Request failed: ${response.status}`)
      }
    }
  }

  const onSubmit = async event => {
    event.preventDefault()
    try {
      await saveFormData()
      if (values.mathtest === "4" || values.mathtest === "22") {
        setValues({
          mailSent: true,
          error: false,
          name: "",
          email: "",
          subject: "",
          message: "",
          mathtest: "",
        })
      } else {
        setValues({
          mailSent: false,
          error:
            "Sadly, you did not complete the math problem correctly. If you are not a robot, please try again. If you are math-challenged, try to reach out via LinkedIn.",
          name: "",
          email: "",
          subject: "",
          message: "",
          mathtest: "",
        })
      }
    } catch (e) {
      setValues({
        error:
          "Your math was correct but, something else went wrong. We apologize for any inconvenience this has caused.",
      })
    }
  }

  return (
    <form id="ContactForm" className={style.form} onSubmit={onSubmit}>
      <div>All fields are required.</div>
      <div>
        {values.mailSent && (
          <div className={style.success}>
            Your message has been sent. Thank you.
          </div>
        )}
        {values.error && <div className={style.error}>{values.error}</div>}
      </div>
      <div>
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          name="name"
          id="name"
          value={values.name}
          required
          onChange={set("name")}
        />
      </div>
      <div>
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          name="email"
          id="email"
          value={values.email}
          required
          onChange={set("email")}
        />
      </div>
      <div>
        <label htmlFor="subject">Subject:</label>
        <input
          type="text"
          name="subject"
          id="subject"
          value={values.subject}
          required
          onChange={set("subject")}
        />
      </div>
      <div>
        <label htmlFor="message">Message:</label>
        <textarea
          name="message"
          id="message"
          rows="5"
          value={values.message}
          required
          onChange={set("message")}
        />
      </div>
      <fieldset className={style.mathtest}>
        <legend id="math-test-label-2">
          The following question is to prevent automated spam submissions.
        </legend>
        <div>
          <label htmlFor="mathtest">2 + 2 = </label>
          <input
            type="number"
            name="mathtest"
            id="mathtest"
            value={values.mathtest}
            aria-labelledby="math-test-label-2"
            required
            onChange={set("mathtest")}
          />
        </div>
      </fieldset>
      <button>Send message</button>
    </form>
  )
}

export default Form
